import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  HttpService,
  NotificationService,
  PurchaseOrderPurchaseAllocation,
  TmsWebBaseEditCreateService,
} from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderPoAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderPurchaseAllocation,
  PurchaseOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(
      'PurchaseOrderPoAllocation',
      $localize`Purchase Order Purchase Order Allocation`,
      httpService,
      notificationService,
    );
  }

  allocate(purchaseOrderLineId: string, purchaseOrderLineRequirementId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineId,
      purchaseOrderLineRequirementId,
    });
  }

  updatePurchaseOrderPurchaseAllocation(purchaseOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderPurchaseAllocation`, {
      purchaseOrderPurchaseAllocationId,
      quantity,
    });
  }
}
